'use client';

import { MXLockerLogoSmall } from '@c/icons/MXLockerLogoSmall';
import Toggle from '@ui/Toggle';

type Props = {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
};

export default function MXDirectFilterPill({ enabled, onChange }: Props) {
  return (
    <div className="flex h-[4.5rem] items-center gap-x-3 rounded-full bg-[#F1F1F1] pl-3 pr-4 sm:rounded-[1.5rem]">
      <div className="size-12 rounded-full bg-brand-secondary p-1 sm:rounded-xl">
        <MXLockerLogoSmall fill="white" className="size-full" />
      </div>
      <Toggle enabled={enabled} onChange={onChange} />
    </div>
  );
}
